<template>
  <div>
    <view-component title="Data Instansi" :schema="schema" class="my-2" @edit="onEdit" />
    <base-modal-full ref="modal" generalError title="Update Data Instansi" @save="onSave">
      <formulir-instansi ref="formulir" :initValue="formulir.init" :masters="masters" :detail="formulir.detail" />
    </base-modal-full>
  </div>
</template>

<script>
import ViewComponent from '../base/View';
import FormulirInstansi from '../forms/Instansi';
import { mapActions } from 'vuex';

export default {
  name: 'Instansi',
  components: { ViewComponent, FormulirInstansi },
  props: {
    index: {
      type: Object,
      default: () => {},
    },
    edit: {
      type: Object,
      default: () => {},
    },
    biodata: {
      type: Object,
      default: () => {},
    },
    biodataEdit: {
      type: Object,
      default: () => {},
    },
    keyBiodataUpdates: {
      type: Array,
      default: () => [],
    },
    kVervalPsp: {
      type: Number,
      default: 1,
    },
    isEditBiodata: {
      type: Boolean,
      default: false,
    },
    masters: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      formulir: {},
      mBedaInstansi: {
        51001: 'Ya',
        51002: 'Tidak',
        51003: 'Tidak memiliki Instansi',
      },
      mBedaTugas: {
        51001: 'Tidak',
        51002: 'Ya',
        51003: 'Tidak memiliki Instansi',
      },
    };
  },
  computed: {
    ptk() {
      return this.$getDeepObj(this.biodata, 'ptk') || {};
    },

    pspProfil() {
      return this.$getDeepObj(this.biodata, 'psp_profil') || {};
    },

    schema() {
      return [
        { title: 'Data Instansi (yang ada di CV saat pendaftaran)', items: this.instansiDaftar },
        { title: 'Data Instansi (saat ini)', items: this.instansiSekarang },
        { title: 'Data Instansi (induk)', items: this.instansiInduk },
      ];
    },

    instansiDaftar() {
      return [
        {
          label: 'Nama Instansi',
          value: this.pspProfil.instansi_nama || '-',
        },
        {
          label: 'Alamat Instansi',
          value: this.pspProfil.instansi_alamat || '-',
        },
        {
          label: 'Provinsi Instansi',
          value: this.$getDeepObj(this.pspProfil, 'm_propinsi_instansi.keterangan') || '-',
        },
        {
          label: 'Kabupaten/Kota Instansi',
          value: this.$getDeepObj(this.pspProfil, 'm_kota_instansi.keterangan') || '-',
        },
        {
          label: 'Website Instansi',
          value: this.pspProfil.instansi_situs || '-',
        },
      ];
    },

    instansiSekarang() {
      return [
        {
          label: 'Apakah instansi Anda saat ini berubah dari yang ada di CV saat pendaftaran?',
          value:
            this.biodata.k_beda_instansi_psp === null ? '' : this.mBedaInstansi[this.biodata.k_beda_instansi_psp] || '',
          update: this.keyBiodataUpdates.includes('k_beda_instansi_psp'),
          size: 12,
        },
        {
          label: 'Nama Instansi',
          value: this.biodata.instansi_nama || '',
          update: this.keyBiodataUpdates.includes('instansi_nama'),
          hidden: this.biodata.k_beda_instansi_psp !== 51001,
        },
        {
          label: 'Alamat Instansi',
          value: this.biodata.instansi_alamat || '',
          update: this.keyBiodataUpdates.includes('instansi_alamat'),
          hidden: this.biodata.k_beda_instansi_psp !== 51001,
        },
        {
          label: 'Provinsi Instansi',
          value: this.$getDeepObj(this.biodata, 'm_propinsi_instansi.keterangan') || '',
          update: this.keyBiodataUpdates.includes('instansi_k_propinsi'),
          hidden: this.biodata.k_beda_instansi_psp !== 51001,
        },
        {
          label: 'Kabupaten/Kota Instansi',
          value: this.$getDeepObj(this.biodata, 'm_kota_instansi.keterangan') || '',
          update: this.keyBiodataUpdates.includes('instansi_k_kota'),
          hidden: this.biodata.k_beda_instansi_psp !== 51001,
        },
        {
          label: 'Website Instansi',
          value: this.biodata.instansi_situs || '',
          update: this.keyBiodataUpdates.includes('instansi_situs'),
          hidden: this.biodata.k_beda_instansi_psp !== 51001,
        },
      ];
    },

    instansiInduk() {
      return [
        {
          label: 'Apakah instansi Saat Ini sama dengan Instansi Induk Anda?',
          value: this.biodata.k_beda_tugas_psp === null ? '' : this.mBedaTugas[this.biodata.k_beda_tugas_psp] || '',
          update: this.keyBiodataUpdates.includes('k_beda_tugas_psp'),
          size: 12,
        },
        {
          label: 'Nama Instansi',
          value: this.biodata.tugas_nama || '',
          update: this.keyBiodataUpdates.includes('tugas_nama'),
          hidden: this.biodata.k_beda_tugas_psp !== 51001,
        },
        {
          label: 'Alamat Instansi',
          value: this.biodata.tugas_alamat || '',
          update: this.keyBiodataUpdates.includes('tugas_alamat'),
          hidden: this.biodata.k_beda_tugas_psp !== 51001,
        },
        {
          label: 'Provinsi Instansi',
          value: this.$getDeepObj(this.biodata, 'm_propinsi_tugas.keterangan') || '',
          update: this.keyBiodataUpdates.includes('tugas_k_propinsi'),
          hidden: this.biodata.k_beda_tugas_psp !== 51001,
        },
        {
          label: 'Kabupaten/Kota Instansi',
          value: this.$getDeepObj(this.biodata, 'm_kota_tugas.keterangan') || '',
          update: this.keyBiodataUpdates.includes('tugas_k_kota'),
          hidden: this.biodata.k_beda_tugas_psp !== 51001,
        },
        {
          label: 'Website Instansi',
          value: this.biodata.tugas_situs || '',
          update: this.keyBiodataUpdates.includes('tugas_situs'),
          hidden: this.biodata.k_beda_tugas_psp !== 51001,
        },
      ];
    },
  },
  methods: {
    ...mapActions('biodata', ['actions']),

    onEdit() {
      if (!this.isEditBiodata) {
        this.$error('Data tidak bisa diubah karena telah diajukan');
        return;
      }

      if (this.index.tutup) {
        this.$error(this.index.tutup);
        return;
      }

      this.$set(this.formulir, 'init', null);
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'init', this.biodata);
      });
    },

    onSave() {
      const params = this.$refs.formulir.getValue();

      this.actions({ params, update: this.$isObject(this.edit), action: 'save-instansi' })
        .then(() => {
          this.$success('Berhasil disimpan');
          this.$refs.modal.dialog = false;
          this.$emit('reload');
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },
  },
};
</script>

<style scoped></style>
